import { User } from "./User";

export class Note {
    public id: number;
    public entityType: string;
    public entityId: number;
    public content: string;
    public createdAt: Date;
    public updatedAt: Date;
    public createdByUser: User;

    public constructor(payload?: any) {
        this.id = payload && payload.id ? payload.id : null;
        this.entityType = payload && payload.entityType ? payload.entityType : null;
        this.entityId = payload && payload.entityId ? payload.entityId : null;
        this.content = payload && payload.content ? payload.content : null;
        this.createdAt = new Date(payload.createdAt);
        this.updatedAt = new Date(payload.updatedAt);
        this.createdByUser = new User(payload.createdByUser);
    }
}

export class GetNotesRequest {
    public entityType: string;
    public entityId: number;

    public constructor(payload) {
        this.entityType = payload && payload.entityType ? payload.entityType : null;
        this.entityId = payload && payload.entityId ? payload.entityId : null;
    }
}

export class EditNoteRequest {
    public id: number;
    public content: string;

    public constructor(payload) {
        this.id = payload.id;
        this.content = payload.content;
    }
}

export class CreateNoteRequest {
    public entityType: string;
    public entityId: number;
    public content: string;

    public constructor(payload) {
        this.entityType = payload.entityType;
        this.entityId = payload.entityId;
        this.content = payload.content;
    }
}